
const getLatestGoodsOrderBillDate = function () {
    return window.localStorage.getItem("latestGoodsOrderBillDate");
}
const getLatestShipStatus = function(){
    return window.localStorage.getItem('getLatestShipStatus')
}

export default {
    state: {
        latestGoodsOrderBillDate:getLatestGoodsOrderBillDate(),
        latestShipStatus:getLatestShipStatus(),
    },
    mutations: {
        setLatestGoodsOrderBillDate(state,latestGoodsOrderBillDate) {
            localStorage.setItem('latestGoodsOrderBillDate', latestGoodsOrderBillDate)
            state.latestGoodsOrderBillDate = latestGoodsOrderBillDate;
        },
        setLatestShipStatus(state,latestShipStatus){
            localStorage.setItem('latestShipStatus', latestShipStatus)
            state.latestShipStatus = latestShipStatus;
        },

    },
    actions: {
        setLatestGoodsOrderBillDate({ commit, state }, latestGoodsOrderBillDate) {
            commit('setLatestGoodsOrderBillDate', latestGoodsOrderBillDate);
        },
        setLatestShipStatus({ commit, state }, latestShipStatus) {
            commit('setLatestShipStatus', latestShipStatus);
        },
        clearRecords({commit, state}){
            commit('setLatestGoodsOrderBillDate',null)
            commit('setLatestShipStatus',null)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/global.js